export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '《天才医仙漫画》讲的是一个怎样的故事？',
    a: '《天才医仙漫画》围绕一名身怀医道天赋的年轻主角展开。他从一介凡人起步，凭借天赋与机缘踏上"医仙之路"，在炼丹、针灸、功法三大体系中不断成长，最终掌握起死回生之力。漫画以医术修炼为内核，兼具成长与热血色彩。',
  },
  {
    q: '漫画的医术修炼体系是如何划分的？',
    a: '整套体系可概括为"三术一径"：炼丹、针灸、功法三大体系并列发展，共同支撑主角由凡入仙的修炼路径。三个体系共享真气这套底层能量，只是输出形式不同——炼丹结合灵药成丹，针灸以针引气通脉，功法负责积累与驾驭真气。',
  },
  {
    q: '炼丹和针灸在体系里分别起什么作用？',
    a: '炼丹主要负责"资源与突破"，通过不同品阶的丹药为治疗和境界提升提供支撑；针灸则负责"运用与疗愈"，是主角最核心的战斗与救人技能。两者一横一纵，共同构成主角医仙之路的主要推动力。',
  },
  {
    q: '主角的修炼境界顺序是什么？',
    a: '医仙之路划分为六大境界：淬体境、聚气境、通脉境、丹炉境、灵针境、医仙境。每个境界都是一次能力跃升，且以前一境界的积淀为前提，构成一条环环相扣的升级脉络。',
  },
  {
    q: '修炼体系分为哪几个流派或分支？',
    a: '主要分为三大分支：炼丹（丹道）、针灸（针道）、功法（法道）。此外还有与之配合的药园体系、师承门派体系等辅助脉络。多数读者会先从"三术"入手，再延伸到药园与传承的细节。',
  },
  {
    q: '想快速了解修炼脉络，应该先看哪些内容？',
    a: '建议先看"医仙之路升级脉络"这篇总览，掌握六大境界的顺序；再分别阅读炼丹、针灸、功法的专题文章，理解三大体系如何并行运作；最后可按兴趣深入药园体系或医道传承的设定。',
  },
];